(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ai26-product-refinements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initAi26Pdp = () => {
      const refinement = document.querySelector('[data-ai26-pdp-refinements]');
      if (!refinement || refinement.dataset.initialized === 'true') return;
      refinement.dataset.initialized = 'true';
      document.body.classList.add('kale-ai26-pdp-active');

      const sizeChart = document.querySelector('.product-single__meta .size-chart__standalone');
      const variantLabel = document.querySelector('.product-single__meta .variant-wrapper .variant__label');
      if (sizeChart && variantLabel && !variantLabel.querySelector('.kale-ai26-size-guide')) {
        const originalBlock = sizeChart.closest('.product-block');
        const title = sizeChart.querySelector('.tool-tip-trigger__title');
        if (title) {
          const icon = title.querySelector('svg');
          title.textContent = 'Guida alle taglie';
          if (icon) title.appendChild(icon);
        }
        sizeChart.classList.add('kale-ai26-size-guide');
        variantLabel.appendChild(sizeChart);
        if (originalBlock && originalBlock.children.length === 0) originalBlock.remove();
      }

      const sticky = refinement.querySelector('[data-ai26-mobile-buy]');
      const stickyButton = refinement.querySelector('[data-ai26-mobile-add]');
      const stickyPrice = refinement.querySelector('[data-ai26-mobile-price]');
      const productSection = document.querySelector('.product-section');
      if (!sticky || !stickyButton || !productSection) return;

      const getNativeButton = () => productSection.querySelector('[data-add-to-cart]');
      const getPrice = () => productSection.querySelector('[data-product-price]');

      const sync = () => {
        const nativeButton = getNativeButton();
        const price = getPrice();
        if (price && stickyPrice) stickyPrice.textContent = price.textContent.trim();
        if (!nativeButton) return;
        stickyButton.disabled = nativeButton.disabled;
        const nativeText = nativeButton.querySelector('[data-add-to-cart-text]');
        if (nativeText && nativeText.textContent.trim()) {
          stickyButton.textContent = nativeText.textContent.trim();
        }
      };

      stickyButton.addEventListener('click', () => {
        const nativeButton = getNativeButton();
        if (nativeButton && !nativeButton.disabled) nativeButton.click();
      });

      productSection.addEventListener('change', () => window.setTimeout(sync, 0));

      const nativeButton = getNativeButton();
      const price = getPrice();
      const mutationObserver = new MutationObserver(sync);
      if (nativeButton) mutationObserver.observe(nativeButton, { attributes: true, childList: true, subtree: true });
      if (price) mutationObserver.observe(price, { childList: true, subtree: true, characterData: true });

      if (nativeButton && 'IntersectionObserver' in window) {
        const visibilityObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const shouldShow = !entry.isIntersecting && window.scrollY > 180;
          sticky.classList.toggle('is-visible', shouldShow);
        }, { threshold: 0.15 });
        visibilityObserver.observe(nativeButton);
      } else {
        const fallback = () => sticky.classList.toggle('is-visible', window.scrollY > 650);
        window.addEventListener('scroll', fallback, { passive: true });
        fallback();
      }

      sync();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAi26Pdp, { once: true });
    } else {
      initAi26Pdp();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
